import breakpoints from './breakpoints';
import colors from './colors';
import radii from './radius';
import typography from './typography';
import shadows from './shadows';
import sizes from './sizes';
import { spacing } from './spacing';

const theme = {
  breakpoints,
  radii,
  colors,
  ...typography,
  sizes,
  space: spacing,
  shadows,
};

export default theme;
